/* eslint-disable @typescript-eslint/no-unused-vars */

import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { getMessaging, getToken, onMessage } from '@firebase/messaging';
import { initializeApp } from '@firebase/app';

import Swal from 'sweetalert2';
import { AuthService } from '../../../services/auth.service';
import { NotificationService } from '../../../services/notification.service';

initializeApp(environment.firebaseConfig);
const messaging = getMessaging();
@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerRegister {
  message: any = null;
  constructor(
    private AuthService: AuthService,
    private notificationService: NotificationService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  publicApi(key: string = environment.firebaseConfig.apiKey): void {
    if (isPlatformBrowser(this.platformId)) {
      let script: any;
      // eslint-disable-next-line prefer-const
      script = document.createElement('script');

      if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
          const path = environment.path;
          const scope = environment.scope;

          navigator.serviceWorker
            .register(path, { scope })
            .then(registration => {
              this.requestPermission(registration);
              this.listen();
            })
            .catch(error => {});
        });
      }
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }

  requestPermission(sw: any): void {
    getToken(messaging, {
      vapidKey: environment.firebaseConfig.vapidKey,
      serviceWorkerRegistration: sw
    })
      .then((currentToken: any) => {
        // eslint-disable-next-line no-console
        console.log(currentToken);
        
        if (currentToken) {
          this.AuthService.FCMtoken.next(currentToken);
        } else {
          // alert(
          //   'No registration token available. Request permission to generate one.'
          // );
        }
      })
      .catch((err: any) => {
        // alert(err);
      });
  }
  listen(): void {
    onMessage(messaging, (payload: any) => {
      this.notificationService.showDot.next(true);

      // console.log('payload: ', payload);

      // Extract the product image and name from the push notification payload
      const productImage = payload.data.productImage;
      const productName = payload.data.productName;

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        timerProgressBar: true,
        showCancelButton: false,
        showCloseButton: true,
        showConfirmButton: false,
        timer: 100000,
        padding: '2rem'
        // customClass: 'swal-wide noti_modal'
      });

      // Create an HTML element for the product image and name
      const content = document.createElement('div');

      // Create an image element
      const image = document.createElement('img');
      image.src = productImage;
      image.alt = productName;
      content.appendChild(image);

      // Create a paragraph element for the product name
      const name = document.createElement('p');
      name.textContent = productName;
      content.appendChild(name);

      // Display the toast notification with the custom content
      // Toast.fire({
      //   title: payload.notification.title
      //   // html: content
      // });

      // Add a click event listener to the toast container
      const toastContainer = document.querySelector('.swal2-container');
      toastContainer?.addEventListener('click', event => {
        const target = event.target as Element;
        if (target.classList.contains('swal2-close')) {
          // User clicked the close button, close the toast
          Swal.close();
        } else {
          // User clicked anywhere else, perform the redirection
          // window.location.href = `http://localhost:4200/account/currentorderpage?id=${payload.data.bookingId}`;
        }
      });

      // Optionally assign the payload to a variable for further use
      this.message = payload;
    });
  }
}
